import type { NuxtApp } from '#app'

// `useAsyncData`'s `getCachedData` treats `undefined` as a cache miss (it
// re-runs the handler) and any other return as a hit. The naive shape
//
//     nuxtApp.payload.data[key] ?? nuxtApp.static?.data?.[key]
//
// collapses a legitimately-cached `null` to `undefined` via `??`, which
// causes every null-valued entry to refetch on client hydration. That
// bit us hard on `translations-nl` (no `nl/translations.md` exists, so
// the SSR query resolved to `null`): the client re-ran the handler,
// invoked `@nuxt/content`'s client runtime, and pulled in
// `database.client.js` + `sqlite3.wasm` (~400 KiB) on every cold load.
//
// Use `in`-checks so we hand back the cached `null` directly. Only
// truly-missing keys come back as `undefined` (handler re-runs as
// intended).
export const persistentCache = {
  getCachedData(key: string, nuxtApp: NuxtApp) {
    if (key in nuxtApp.payload.data) return nuxtApp.payload.data[key]
    const staticData = nuxtApp.static?.data
    if (staticData && key in staticData) return staticData[key]
    return undefined
  },
}
